<template>
<v-content class="technologies-tab">

  <v-sparkline :fill="fill" :label-size="labelSize" :value="value" :labels="labels" :padding="padding" :line-width="width" :type="type" auto-draw></v-sparkline>
  <v-subheader class="overline">Level of knoweldge in each {{ typeTech }}</v-subheader>
  <v-divider></v-divider>
</v-content>
</template>

<script>
export default {
  name: 'TechnologiesTab',
  props: {
    technologies: Array,
    typeTech: String
  },
  data() {
    return {
      width: 8,
      radius: 0,
      padding: 0,
      type: 'bar',
      labelSize: 8,
      value: [],
      labels: [],
      fill: true,
    }
  },
  created() {

    for (var i = 0; i < this.technologies.length; i++) {
      if (this.technologies[i].type === this.typeTech) {
        this.value.push(this.technologies[i].knowledge);
        this.labels.push(this.technologies[i].name);
      }
    }
  }
}
</script>
